import React from 'react'
import './play.sass'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Play = () => (
  <div className="play-btn">
    <FontAwesomeIcon icon={['fas', 'play']} className="play" />
  </div>
)

export default Play
